import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { signOut } from '../pages/auth/services/signin/slice';
import { removeToken, isAdmin } from '../utils/auth';

const TopNav: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    dispatch(signOut());
    navigate('/');
  };

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.innerWidth < 992) {
      // Mobile: fire custom event — Layout listens and slides the drawer
      window.dispatchEvent(new Event('ev-toggle-mobile-sidebar'));
    } else {
      // Desktop: toggle nav-md / nav-sm body classes
      const body = document.body;
      if (body.classList.contains('nav-md')) {
        body.classList.remove('nav-md');
        body.classList.add('nav-sm');
      } else {
        body.classList.remove('nav-sm');
        body.classList.add('nav-md');
      }
    }
  };

  return (
    <div className="top_nav">
      <div className="nav_menu">
        {/* Hamburger toggle */}
        <nav className="nav toggle">
          <a id="menu_toggle" href="#!" onClick={handleToggle}>
            <i className="fas fa-bars" />
          </a>
        </nav>

        {/* Right side */}
        <nav className="nav navbar-nav ms-auto">
          <ul className="navbar-right d-flex align-items-center gap-3 pe-3 mb-0">
            <li className="nav-item">
              <span style={{ fontSize: 13, color: '#73879c' }}>
                <i className="bi bi-lightning-charge-fill text-warning me-1" />
                EV Care Admin
              </span>
            </li>
            <li className="nav-item dropdown">
              <a
                href="#!"
                className="user-profile dropdown-toggle"
                id="navbarDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={(e) => e.preventDefault()}
              >
                <img src="/images/user.png" alt="User" />
                {isAdmin() ? 'Admin' : 'Vendor'}
              </a>
              <div
                className="dropdown-menu dropdown-menu-end dropdown-usermenu"
                aria-labelledby="navbarDropdown"
              >
                <button className="dropdown-item" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt me-2" />
                  Log Out
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default TopNav;
